import { create } from 'zustand';
import { message } from 'antd';
import { login as apiLogin, getProfile } from '../api/auth';
import { AxiosResponse } from 'axios';
import { handleApiError } from '../utils/errorHandler';

interface AuthResponse {
  access_token: string;
  user: any;
}

interface AuthState {
  token: string | null;
  user: any | null;
  role: string | null;
  identity: string | null;
  loading: boolean;
  login: (username: string, password: string) => Promise<boolean>;
  logout: () => void;
  checkAuth: () => Promise<boolean>;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  token: localStorage.getItem('token'),
  user: null,
  role: localStorage.getItem('role'),
  identity: localStorage.getItem('identity'),
  loading: false,

  login: async (username: string, password: string) => {
    try {
      set({ loading: true });
      const response: AxiosResponse = await apiLogin(username, password);
      
      // 假设API响应数据在response.data中
      const data = response.data as AuthResponse;
      
      if (data && data.access_token) {
        localStorage.setItem('token', data.access_token);
        const role = data.user?.role || 'admin';
        const identity = data.user?.identity || 'admin';
        localStorage.setItem('role', role);
        localStorage.setItem('identity', identity);
        set({ token: data.access_token, user: data.user, role, identity, loading: false });
        return true;
      } else {
        message.error('登录失败，请检查用户名和密码');
        set({ loading: false });
        return false;
      }
    } catch (error) {
      handleApiError(error, '登录失败，请稍后重试');
      set({ loading: false });
      return false;
    }
  },

  logout: () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    localStorage.removeItem('identity');
    set({ token: null, user: null, role: null, identity: null });
    message.success('已退出登录');
  },

  checkAuth: async () => {
    const { token } = get();
    
    if (!token) {
      return false;
    }
    
    try {
      set({ loading: true });
      const response = await getProfile();
      // 假设API响应数据在response.data中
      const user = response.data;
      const role = user?.role || 'admin';
      const identity = user?.identity || 'admin';
      localStorage.setItem('role', role);
      localStorage.setItem('identity', identity);
      set({ user, role, identity, loading: false });
      return true;
    } catch (error) {
      handleApiError(error, '认证检查失败', false); // 不显示错误消息
      localStorage.removeItem('token');
      localStorage.removeItem('role');
      localStorage.removeItem('identity');
      set({ token: null, user: null, role: null, identity: null, loading: false });
      return false;
    }
  },
}));
